// extracted by mini-css-extract-plugin
export default {"build-setting":"buildSetting_build-setting__i8z+P"};